"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_ROLE_TO_DEPARTMENT_ROLE = exports.PRODUCER_DEPARTMENT_ROLES = exports.ACCOUNT_MANAGER_DEPARTMENT_ROLES = exports.PC_ROLES = exports.ROLE_MAPPING_DOWNGRADE_MAP = exports.ACCOUNT_ASSIGNMENT_ROLE_IDS = exports.EXTERNAL_ROLE_IDS = exports.EMPLOYEE_ROLE_IDS = void 0;
const auth_api_1 = require("@newfront-insurance/auth-api");
const types_1 = require("./types");
exports.EMPLOYEE_ROLE_IDS = [
    ...Object.values(types_1.AccountManagementAssignmentRole),
    ...Object.values(types_1.ProducerAssignmentRole),
];
exports.EXTERNAL_ROLE_IDS = Object.values(types_1.ExternalAssignmentRole);
exports.ACCOUNT_ASSIGNMENT_ROLE_IDS = [
    ...exports.EMPLOYEE_ROLE_IDS,
    ...Object.values(types_1.ExternalAssignmentRole),
];
exports.ROLE_MAPPING_DOWNGRADE_MAP = {
    PRIMARY_ACCOUNT_MANAGER: types_1.AccountManagementAssignmentRole.SECONDARY_ACCOUNT_MANAGER,
    PRIMARY_PRODUCER: types_1.ProducerAssignmentRole.SECONDARY_PRODUCER,
};
exports.PC_ROLES = [
    types_1.DepartmentRole.COMMERCIAL_LINES_ACCOUNT_MANAGER,
    types_1.DepartmentRole.COMMERCIAL_LINES_PRODUCER,
    types_1.DepartmentRole.PERSONAL_LINES_ACCOUNT_MANAGER,
    types_1.DepartmentRole.PERSONAL_LINES_PRODUCER,
];
exports.ACCOUNT_MANAGER_DEPARTMENT_ROLES = [
    types_1.DepartmentRole.COMMERCIAL_LINES_ACCOUNT_MANAGER,
    types_1.DepartmentRole.PERSONAL_LINES_ACCOUNT_MANAGER,
    types_1.DepartmentRole.EMPLOYEE_BENEFITS_ACCOUNT_MANAGER,
];
exports.PRODUCER_DEPARTMENT_ROLES = [
    types_1.DepartmentRole.COMMERCIAL_LINES_PRODUCER,
    types_1.DepartmentRole.PERSONAL_LINES_PRODUCER,
    types_1.DepartmentRole.EMPLOYEE_BENEFITS_PRODUCER,
];
exports.AUTH_ROLE_TO_DEPARTMENT_ROLE = {
    [auth_api_1.AuthRole.CL_ACCOUNT_MANAGER]: types_1.DepartmentRole.COMMERCIAL_LINES_ACCOUNT_MANAGER,
    [auth_api_1.AuthRole.PL_ACCOUNT_MANAGER]: types_1.DepartmentRole.PERSONAL_LINES_ACCOUNT_MANAGER,
    [auth_api_1.AuthRole.EB_ACCOUNT_MANAGER]: types_1.DepartmentRole.EMPLOYEE_BENEFITS_ACCOUNT_MANAGER,
    [auth_api_1.AuthRole.CL_PRODUCER]: types_1.DepartmentRole.COMMERCIAL_LINES_PRODUCER,
    [auth_api_1.AuthRole.PL_PRODUCER]: types_1.DepartmentRole.PERSONAL_LINES_PRODUCER,
    [auth_api_1.AuthRole.EB_PRODUCER]: types_1.DepartmentRole.EMPLOYEE_BENEFITS_PRODUCER,
};
//# sourceMappingURL=util.js.map